







































































































































import { FindImportacaoUseCase, SaveMetaDiariaUseCase } from '@/usecases';
import { Component, Vue } from 'vue-property-decorator';
import AlertModule from '@/store/vuex/aplicacao/AlertModule';
import { uploadFilesToS3 } from '@/shareds/s3/files';
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore';
import type { Operador } from '@/models/venda/Operador';

@Component
export default class DialogoDeCsvDeMetas extends Vue {
	mostra = false
	tab: null | number = 0
	tabs = [
		{ action: 'Importar', icon: 'mdi-file-upload' },
		{ action: 'Exportar', icon: 'mdi-download' },
	]
	saveUseCase = new SaveMetaDiariaUseCase()
	findImportacaoUseCase = new FindImportacaoUseCase()
	importando = false
	exportando = false
	arquivoCsv: File[] = []
	metaNome: string | null = null
	metaId: string | null = null
	vendedores: Operador[] = []
	selecionado: boolean | null = null
	mes: number | null = null
	ano: number | null = null

	async mostrar(metaId?: string, metaNomeRecebido?: string, vendedores: Operador[] = []) {
		this.metaId = metaId ? metaId : null
		this.metaNome = metaNomeRecebido ? metaNomeRecebido : null
		this.vendedores = vendedores
		this.mostra = true
	}

	cancelar() {
		this.importando = false
		this.mostra = false
		this.arquivoCsv = []
		this.mes = null
		this.ano = null
	}

	get meses() {
		return [
			{ label: 'Janeiro', value: 1 },
			{ label: 'Fevereiro', value: 2 },
			{ label: 'Março', value: 3 },
			{ label: 'Abril', value: 4 },
			{ label: 'Maio', value: 5 },
			{ label: 'Junho', value: 6 },
			{ label: 'Julho', value: 7 },
			{ label: 'Agosto', value: 8 },
			{ label: 'Setembro', value: 9 },
			{ label: 'Outubro', value: 10 },
			{ label: 'Novembro', value: 11 },
			{ label: 'Dezembro', value: 12 },
		];
	}

	get anos() {
		const atual = new Date().getFullYear();
		const lista: number[] = [];
		for (let a = atual - 2; a <= atual + 2; a += 1) lista.push(a);
		return lista;
	}

	get usuario() {
		return UserLoginStore.usuario?.id
	}

	get permiteAbrirDiversosProcessosDeImportacao(){
		if(!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}

	async concluirImportacao() {
		if (this.arquivoCsv.length == 0) {
			return AlertModule.setError("É obrigatório selecionar um arquivo")
		}
		if (!this.metaId) {
			return;
		}

		if(!this.usuario) return

		if(!this.permiteAbrirDiversosProcessosDeImportacao){
			const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(this.usuario)

			if(!possuiProcessoEmAberto){
				AlertModule.setError('Já existe um processo em aberto para o usuário, aguarde finalizar para prosseguir!')
				this.importando = false
				return
			}
		}

		if (!this.mes || !this.ano){
			return AlertModule.setError("Obrigatório preencher mês e ano.")
		}

		try {
			this.importando = true;

			const informacoesDosArquivos = await uploadFilesToS3(
				this.arquivoCsv,
				`importacao-meta-diaria`,
			);
			const urlDoArquivo = informacoesDosArquivos.map(({ config }) => config.url)[0]

			if (!urlDoArquivo) {
				return AlertModule.setError("Ocorreu um erro interno, contate o suporte")
			}

			await this.saveUseCase.importarMetasDiarias(
				this.metaId,
				this.mes,
				this.ano,
				urlDoArquivo,
			);

			AlertModule.setSuccess('Itens em processamento')
			this.$emit('concluiuImportacao')
			this.cancelar()
		} catch (e) {
			this.importando = false
			AlertModule.setError(e)
		}
	}

	get diasNoMes() {
		if (!this.mes || !this.ano) return 0
		// JS: mês é 0-based no Date; último dia do mês: new Date(ano, mes, 0)
		return new Date(this.ano, this.mes, 0).getDate()
	}

	private gerarConteudoModeloCsv(): string {
		if (!this.mes || !this.ano) return ''

		const dias = this.diasNoMes
		const header = ['cpf', ...Array.from({ length: dias }, (_, i) => String(i + 1))].join(';')

		const linhasVendedores = this.vendedores
			.filter(v => v.cpf)
			.map(v => [v.cpf!.replace(/\D/g, ''), ...Array.from({ length: dias }, () => '')].join(';'))

		const linhas = linhasVendedores.length > 0
			? linhasVendedores
			: [['00000000000', ...Array.from({ length: dias }, () => '')].join(';')]

		return `${header}\n${linhas.join('\n')}\n`
	}

	private downloadTextFile(filename: string, content: string) {
		const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' })
		const url = URL.createObjectURL(blob)

		const a = document.createElement('a')
		a.href = url
		a.download = filename
		document.body.appendChild(a)
		a.click()
		a.remove()

		URL.revokeObjectURL(url)
	}

	async baixarModeloCsv() {
		if (!this.mes || !this.ano) {
			return AlertModule.setError('Obrigatório preencher mês e ano.')
		}

		try {
			this.exportando = true

			const mm = String(this.mes).padStart(2, '0')
			const filename = `modelo-meta-diaria-${this.ano}-${mm}.csv`

			const content = this.gerarConteudoModeloCsv()
			this.downloadTextFile(filename, content)

			AlertModule.setSuccess('Modelo baixado com sucesso.')
		} finally {
			this.exportando = false
		}
	}
	
}
